<body>
  <div class="background">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="logo">
            <img src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/logo.png" alt="logo" />
          </div>
        </div>
        <div class="col-lg-6 text-right">
          <div class="social-image">
            <a href="http://onpassive.com/blog">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon/blog.png"
                alt="blog"
                title="ONPASSIVE Blog"
                class="icon"
              />
            </a>
            <a href="https://www.facebook.com/ONPASSIVE/ONPASSIVE">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon/fb.png"
                alt="facebook"
                title="Facebook"
                class="icon"
              />
            </a>
            <a href="https://twitter.com/ONPASSIVE">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-2)/image/icon/twitter.png"
                alt="Twitter"
                title="Twitter"
                class="icon"
              />
            </a>
            <a href="https://www.instagram.com/ONPASSIVE/">
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-2)/image/icon/insta.png"
                title="Instagram"
                class="icon"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-2)/image/icon/youtube.png"
                alt="YouTube"
                title="Youtube"
                class="icon"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon/in.png"
                alt="LinkedIn"
                title="LinkedIn"
                class="icon"
              />
            </a>
          
          </div>
        </div>
        <!-------------second-section--------------------->
        <!------------------------------------------------>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="icons">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon4.png"
              class="image-rotate-scnd icon4"
              alt="icon4"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon6.png"
              class="rotate icon6"
              alt="icon6"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon10.png"
              class="image-rotate-scnd icon10"
              alt="icon10"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon11.png"
              class="rotate icon11"
              alt="icon11"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon5.png"
              class="image-rotate-scnd icon5"
              alt="icon5"
            />
          </div>
          <img
            src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/robot.png"
            class="robot"
            alt="robot"
          />
          <div class="icons1">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon3.png"
              class="rotate icon3"
              alt="icon3"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon2.png"
              class="image-rotate-scnd icon2"
              alt="icon2"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon8.png"
              class="rotate icon8"
              alt="icon8"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-2)/image/icon9.png"
              class="image-rotate-scnd icon9"
              alt="icon9"
            />
          </div>
         
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <div class="content">
               
                <marquee direction="down">
                  <h2 class="content2">LAUNCHING SOON</h2>
                </marquee>
                <h3 class="content1">
                  <p>
                    No matter how many times you fall, you can always choose
                    whether or not to get back up. We at ONPASSIVE believe that
                    it is never too late to succeed in life. With the help of
                    artificial intelligence, we offer a wide range of network
                    marketing services to help businesses to grow from simple
                    beginnings to game-changing success. Join us if you believe
                    you need a change too.
                  </p>
                </h3>
              </div>
              <div class="video-box">
                <video
                  id="my-video"
                  class="video-js w-100"
                  controls
                  preload="auto"
                  poster="{{
                    myLinksS3URL
                  }}frontend/greetingsgofound3/images/greeting2.png"
                  data-setup="{}"
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video2.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
              <div class="bfn mt-3 text-center">
                <a
                  href="/registration/user?reg={{ userId }}"
                  name="regform"
                  class="btn text-uppercase"
                  target="_blank"
                  rel="noopener"
                  >become a founder now</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
